import axios from "axios";

const URL_INDICADORES = '/api/indicadores'

export default class IndicadoresService {

    static getIndicadores(params) {
        return axios.get( `${URL_INDICADORES}`, {params} ).catch(err => console.err(err));
    }

    static getNombreIndicadores() {
        return axios.get( `${URL_INDICADORES}/nombres` ).catch(err => console.err(err));
    }
    
    static getIndicador( id, params ){
        return axios.get( `${URL_INDICADORES}/${id}`, {params} ).catch(err => console.err(err));
    }

    static getFavoritos( params ){
        return axios.get( `${URL_INDICADORES}/favoritos`, {params}  ).catch(err => console.err(err));
    }
}